<script lang="ts">
  import { _ } from 'svelte-i18n';
  import StatusMark from './StatusMark.svelte';
  import { withUnit } from './format';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // A race's TP, HIE and PP from the start to the race, each against its target (race_hero of the report).
  export let hero: any;
</script>

<h3 class="text-sm font-medium mb-1 text-zinc-600">{$_('report.table.power_capability')}</h3>
<table class="w-full text-sm mb-4">
  <thead>
    <tr class="text-left text-zinc-500">
      <th class="font-normal py-1">{$_('report.table.measure')}</th>
      <th class="font-normal py-1 text-right">{$_('report.overview.start')}</th>
      <th class="font-normal py-1 pl-8 text-right">{hero.source ? $_('report.race.at_race') : $_('report.overview.end')}</th>
      <th class="font-normal py-1 pl-8 text-right">{$_('report.table.target')}</th>
      <th class="w-8" />
    </tr>
  </thead>
  <tbody>
    {#each hero.measures as m}
      <tr class="border-t">
        <td class="py-1.5">{m.label}</td>
        <td class="py-1.5 text-right tabular-nums whitespace-nowrap">{m.start !== null ? withUnit(m.unit, m.start) : '–'}</td>
        <td class="py-1.5 pl-8 text-right tabular-nums whitespace-nowrap">{m.finish !== null ? withUnit(m.unit, m.finish) : '–'}</td>
        <td class="py-1.5 pl-8 text-right tabular-nums whitespace-nowrap">{m.target !== null ? withUnit(m.unit, m.target) : '–'}</td>
        <td class="py-1.5 text-center"><StatusMark status={m.status} /></td>
      </tr>
    {/each}
  </tbody>
</table>
{#if hero.source === 'breakthrough'}
  <p class="-mt-2 mb-4 text-xs text-amber-700 font-medium">{$_('report.race.breakthrough_before')} {#each hero.before_race ? [['TP', 'W', 'ftp'], ['HIE', 'J', 'hie'], ['PP', 'W', 'pp']] : [] as [label, unit, key], i}{i ? ', ' : ''}{label} {withUnit(unit, hero.before_race[key])}{/each}.</p>
{:else if hero.source === 'predicted'}
  <p class="-mt-2 mb-4 text-xs text-zinc-500">{$_('report.race.no_breakthrough')}</p>
{/if}
